var p = Object.defineProperty;
var c = (r, s, e) => s in r ? p(r, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[s] = e;
var i = (r, s, e) => c(r, typeof s != "symbol" ? s + "" : s, e);
import { HttpClient as u, httpClient as n } from "../../httpClient.js";
class a extends u {
  constructor() {
    super(...arguments);
    i(this, "endpoint", "/user-projects");
  }
  async getAll(e) {
    return n.get(this.endpoint, { params: e });
  }
  async create(e, t) {
    const o = typeof t == "number" ? { id: t } : t;
    return n.post(this.endpoint, { projectId: e, file: o });
  }
  async update(e, t) {
    return n.put(`${this.endpoint}/${e}`, t);
  }
  async remove(e) {
    return n.delete(`${this.endpoint}/${e}`);
  }
  async removeSubmission(e, t) {
    return n.delete(
      `${this.endpoint}/${e}/submissions/${t}`
    );
  }
  async claim(e, t) {
    return n.post(`${this.endpoint}/${e}/claim`, { instructorId: t });
  }
  async disclaim(e) {
    return n.post(`${this.endpoint}/${e}/disclaim`, {});
  }
  async review(e, t) {
    return n.put(`${this.endpoint}/${e}/review`, t);
  }
  async getAllForProject(e, t) {
    return n.get(`/users/${e}/project/${t}`);
  }
}
const l = new a();
export {
  l as default
};
